
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amanaki-boutique-saigon/facilities-service",
      function () {
        return require("private-next-pages/amanaki-boutique-saigon/facilities-service/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amanaki-boutique-saigon/facilities-service"])
      });
    }
  